(async () => {
  if (!document.modelContext?.registerTool) return;
  try {
    await document.modelContext.registerTool({
      name: 'lise_explore_collections',
      description: 'List the collection titles and destinations currently displayed on the Lise Luxury homepage.',
      inputSchema: {type:'object',properties:{},additionalProperties:false},
      annotations: {readOnlyHint:true},
      execute: async () => JSON.stringify([...document.querySelectorAll('.collection-card')].map(card => ({title:card.textContent.trim(),url:card.href})))
    });
  } catch (error) { console.debug('Lise collection tools unavailable', error.name); }
})();
